import { Form, Input, Button, Space, Message } from '@arco-design/web-react';
import {
  IconBranch,
  IconLock,
  IconMobile,
  IconUser,
} from '@arco-design/web-react/icon';
import React, { useEffect, useRef, useState } from 'react';
import styles from './style/index.module.less';
import { register } from '@/request/api';
import { PageTypeLogin } from './constants';
import request from '@/request/request';

export default function CaptchaRegister(props: {
  channelName?: string;
  mobile: string;
  authToken: string;
  onTypeChange?: (arg: number) => void;
  onSuccess?: () => void;
}) {
  const [form] = Form.useForm();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(false);

  function afterLoginSuccess(accessToken) {
    // 记录登录状态
    localStorage.setItem('token', accessToken);
    // 关闭弹框
    props.onSuccess && props.onSuccess();
  }

  async function regist(params) {
    setErrorMessage('');
    setLoading(true);
    try {
      const resp = await request('/apiService/mechanism/login/captcha', {
        data: {
          authCode: props.authToken,
          nickname: params.name,
          channelId: window.localStorage.getItem('channelId') || '',
        },
        method: 'POST',
      });
      if (resp.code === 200) {
        afterLoginSuccess(resp.data.token);
      } else {
        setErrorMessage(resp.message || '登录失败，请稍后重试');
      }
    } catch (e) {
      console.warn('登录失败', e);
    } finally {
      setLoading(false);
    }
  }

  function onSubmitClick() {
    form.validate().then((values) => {
      regist(values);
    });
  }

  useEffect(() => {
    form.setFieldsValue({
      account: props.mobile,
    });
  }, [props.mobile]);

  return (
    <div className={styles['login-form-wrapper']}>
      <div className={styles['login-form-title']} style={{ textAlign: 'left' }}>
        完善资料
      </div>
      <div className={styles['login-form-error-msg']}>{errorMessage}</div>
      <Form className={styles['login-form']} layout="vertical" form={form}>
        <Form.Item field="account" required>
          <Input
            readOnly={true}
            className={styles['login-form-input']}
            prefix={<IconMobile style={{ fontSize: 20 }} />}
            maxLength={11}
            placeholder="请输入手机号"
          />
        </Form.Item>
        <Form.Item
          field="name"
          required
          rules={[
            {
              required: true,
              type: 'string',
              message: '请输入公司名称',
            },
          ]}
        >
          <Input
            prefix={<IconUser style={{ fontSize: 20 }} />}
            placeholder="请输入公司名称"
            className={styles['login-form-input']}
          />
        </Form.Item>
        <Form.Item
          field="password"
          rules={[
            {
              type: 'string',
              minLength: 6,
              maxLength: 20,
              message: '请输入6-20位密码',
            },
          ]}
        >
          <Input.Password
            className={styles['login-form-input']}
            maxLength={20}
            prefix={<IconLock style={{ fontSize: 20 }} />}
            placeholder="选填，设置密码"
          />
        </Form.Item>
        {props.channelName && (
          <Form.Item>
            <Input
              readOnly
              className={styles['login-form-input']}
              prefix={<IconBranch style={{ fontSize: 20 }} />}
              value={props.channelName}
            />
          </Form.Item>
        )}
        <div
          style={{
            width: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
            marginBottom: '16px',
          }}
        ></div>
        <Space size={16} direction="vertical">
          <Button type="primary" long onClick={onSubmitClick} loading={loading}>
            注册
          </Button>
          <Button
            type="text"
            long
            onClick={() => {
              props.onTypeChange && props.onTypeChange(PageTypeLogin);
            }}
          >
            返回登录页
          </Button>
        </Space>
      </Form>
    </div>
  );
}
